<div class="">
  @if (cotStatusTab && pageWorkflow.length === 0) {
    <div class="p-4 pb-0 rounded-lg flex gap-4 flex-col md:flex-row justify-between items-center">
      <app-tab-menu-simple
        class="w-[-webkit-fill-available]"
        [tabs]="taps"
        [indexSelected]="statusSelected"
        (changeSelected)="statusSelected = $event.indexSelected; resetTable()"
        [upgradeSelected]="false"
        [titule]="'menus.workflow' | translate"
      ></app-tab-menu-simple>
      <app-input-general
        [formControlGeneral]="search"
        [placeholder]="'general.search' | translate"
      ></app-input-general>
    </div>

    @if (viewTable && ticketSearchResultPaged) {
      <div class="m-8 p-2 rounded-lg flex flex-col">
        <app-table-general-simple
          class="col-span-full"
          [dataSource]="ticketPaged"
          [headers]="headers"
          [isLoading]="loadService"
          (idEmitter)="getActivityForms($event)"
          [isSticky]="true"
        ></app-table-general-simple>

        <div class="flex md:flex-row flex-col lg:justify-between items-center ml-4 my-4">
          <div></div>
          <mat-paginator
            #paginator
            [length]="ticketSearchResultPaged.totalCount"
            [pageSize]="10"
            [pageIndex]="page - 1"
            (page)="onPageChange($event.pageIndex)"
            [attr.aria-label]="'general.selectPage' | translate"
          >
          </mat-paginator>
        </div>
      </div>
    }
  }

  @if (pageWorkflow.length) {
    <div class="m-4 sm:m-4 md:m-4 lg:m-6 xl:m-6">
      <div class="flex justify-between items-center lg:items-start flex-col">
        <div class="rounded-lg w-full">
          <div class="flex flex-col justify-start">
            <div class="flex gap-2 items-center">
              <app-tab-menu-simple
                class="w-[-webkit-fill-available] py-4"
                [tabs]="normalizecotPageWorkflow"
                [upgradeSelected]="false"
                [indexSelected]="stateFromGrup"
                (changeSelected)="getTabPagues($event.id ?? 0)"
                [titule]="this.cotStatusTab?.[this.statusSelected]?.descripcion || ''"
              ></app-tab-menu-simple>
            </div>
            <div class="right-4 z-50 top-15 lg:right-10 flex justify-end w-auto mx-5 fixed">
              <div
                class="flex flex-col w-max max-w-[90vw] transition-all duration-500 ease-in-out shadow-2xl pointer-events-auto h-max"
                [ngClass]="{
                  'bg-white rounded-3xl shadow-xl/30 inset-shadow-sm': expansion,
                  'rounded-[50px]': !expansion,
                }"
              >
                <div
                  class="bg-(--comp-container-bg) flex justify-between items-center py-0.5 pr-3 transition-all duration-500 ease-in-out"
                  [ngClass]="{
                    'rounded-[50px]': !expansion,
                    'rounded-t-3xl px-2': expansion,
                  }"
                >
                  <div class="flex gap-1 text-base justify-center items-center relative">
                    <img class="size-11" src="assets/icons/icon_auto.svg" alt="" />
                    <div class="font-bold text-white">{{ 'workflow.quotation' | translate }}:</div>
                    <div class="font-medium text-white px-2">{{ quotationId }}</div>
                  </div>

                  <app-change-ticket-status
                    class="w-auto text-white"
                    [phase]="cotStatus ?? []"
                    [statusSelected]="statusSelected"
                    [expansion]="expansion"
                    (emitExpansion)="expansion = $event"
                    (emitIndex)="changeQuotationStatus($event)"
                    (back)="pageWorkflow = []; viewTable = true"
                  ></app-change-ticket-status>
                </div>

                <div
                  class="grid transition-[grid-template-rows,opacity] duration-500 ease-in-out"
                  [ngClass]="{
                    'grid-rows-[1fr] opacity-100': expansion,
                    'grid-rows-[0fr] opacity-0': !expansion,
                  }"
                >
                  <div class="overflow-hidden">
                    <div
                      class="text-general text-(--brand-gray-dark) flex flex-col gap-2 px-6 py-4 bg-white rounded-b-3xl"
                    >
                      @for (quotation of dataQuotation; track $index) {
                        <div class="flex gap-2 border-b border-gray-100 last:border-0 pb-1">
                          <span class="font-bold">{{ quotation.nameData }}:</span>
                          <span class="font-medium"> {{ quotation.value }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-page-general
        [cotStatus]="cotStatus?.[statusSelected] ?? null"
        [idPage]="this.pageWorkflow[stateFromGrup].id"
        [quotationId]="quotationId"
        [starNgOnInit]="true"
        [tollArray]="tollArray"
        (emitFunctionTool)="emitButtonForm($event)"
      ></app-page-general>
    </div>
  }
</div>
<app-load-general [load]="loadService"></app-load-general>
